import type { ObjectValuesAsTypes } from "../../../utils/types";

export const ACCOUNT_TYPES = {
  ANY: "ANY",
  GBP_AND_UK: "GBP_AND_UK",
  GBP_AND_ANY: "GBP_AND_ANY",
  BR_AND_BRL: "BR_AND_BRL",
} as const;

export type AccountFormState = ObjectValuesAsTypes<typeof ACCOUNT_TYPES>;
